import React, { useEffect } from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage1 from "../../assets/img/add/addi1.jpg";
import AddImage2 from "../../assets/img/add/addi2.jpg";
import AddImage3 from "../../assets/img/add/addi4.jpg";
import AddImage4 from "../../assets/img/add/addi3.jpg";
// AOS for animations
import AOS from "aos";
import "aos/dist/aos.css";

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1200, easing: "ease-out-back", once: true });
  }, []);

  return (
    <Wrapper id="services">
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      <div className="whiteBg" style={{ padding: "80px 0" }}>
        <div className="container">
          <HeaderInfo data-aos="fade-up">
            <h1 className="font40 extraBold">Unlock Innovation with Our Expertise</h1>
            <p className="font13">
              From intuitive websites and robust software to captivating designs and seamless apps, we empower your business with solutions that drive success. Let’s create something extraordinary together.
            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex" data-aos="fade-up">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="web"
                title="Web Development"
                subtitle="Elevate your online presence with a custom-built, responsive, and user-friendly website designed to convert visitors into loyal customers."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="software"
                title="Software Development"
                subtitle="From enterprise-level applications to bespoke software, we design scalable solutions that optimize your workflows and drive business efficiency."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="design"
                title="Graphic Design"
                subtitle="Transform your brand’s identity with modern, visually striking designs that captivate and communicate your vision effectively."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="mobile"
                title="App Development"
                subtitle="Reach your audience on-the-go with intuitive and feature-rich mobile apps designed for seamless user experiences on iOS and Android."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter" data-aos="fade-up">
              <AddLeft>
                <h4 className="font15 semiBold">Why Choose Us?</h4>
                <h2 className="font40 extraBold">Innovative, Creative, Tailored Solutions</h2>
                <p className="font13">
                  We focus on delivering custom solutions that are perfectly suited to your business needs. We bring together design, development, and strategy to help you achieve your goals.
                </p>
                <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                  <div style={{ width: "190px" }}>
                    <FullButton title="Get Started" action={() => alert("clicked")} />
                  </div>
                  <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton title="Contact Us" action={() => window.location.href = "tel:+1234567890"} border />
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter" data-aos="zoom-in">
                      <img src={AddImage1} alt="creative brainstorming" />
                    </AddImgWrapp1>
                    <AddImgWrapp2 data-aos="zoom-in">
                      <img src={AddImage2} alt="teamwork in action" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3 data-aos="zoom-in">
                      <img src={AddImage3} alt="coding process" />
                    </AddImgWrapp3>
                    <AddImgWrapp4 data-aos="zoom-in">
                      <img src={AddImage4} alt="design concept" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  background-color: #f4f4f4;
  padding: 20px 0;
`;

const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

const ServiceBoxWrapper = styled.div`
  width: 23%;
  margin-right: 3%;
  padding: 80px 0;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: translateY(-10px);
  }
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;

const HeaderInfo = styled.div`
  text-align: center;
  h1 {
    font-size: 48px;
    font-weight: bold;
    color: #333;
  }
  p {
    font-size: 16px;
    color: #555;
    max-width: 600px;
    margin: 0 auto;
  }
`;

const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;

const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;

const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;

const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;

const AddRightInner = styled.div`
  width: 100%;
`;

const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;

const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;

const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;

const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5% auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
